import React from 'react';
const pains = ["Quotes stuck in someone's inbox", "AWS bills you can't forecast", 'Offshore devs in 4 timezones', 'Spreadsheets duct-taped to spreadsheets', "Tools that don't talk to each other", "Code you don't actually own", 'Support tickets into the void', 'Manual data entry, every Monday'];
export function PainMarquee() {
  const doubled = [...pains, ...pains];
  return <div className="relative overflow-hidden border-y border-ink/10 bg-ink py-4 -mx-4 md:mx-0 md:rounded-2xl" data-id="element-127">
      <div className="flex animate-marquee whitespace-nowrap" data-id="element-128">
        {doubled.map((pain, i) => <div key={i} className="flex items-center gap-6 px-6 text-white/80" data-id="element-129">
            <span className="font-display italic text-lg" data-id="element-130">{pain}</span>
            <span className="text-brand-mint" data-id="element-131">✕</span>
          </div>)}
      </div>
    </div>;
}